import { withSvgIcon } from './withSvgIcon';

export const Projects = withSvgIcon(
  <>
    <circle
      cx="12"
      cy="12"
      r="9"
      stroke="currentColor"
      strokeWidth="currentWidth"
    />
    <path
      d="M12 12C9.51472 12 7.5 9.98528 7.5 7.5C7.5 5.01472 9.51472 3 12 3"
      stroke="currentColor"
      strokeWidth="currentWidth"
    />
    <circle cx="12" cy="7.5" r="1.5" fill="currentColor" />
    <circle cx="12" cy="16.5" r="1.5" fill="currentColor" />
    <path
      d="M12 12C14.4853 12 16.5 14.0147 16.5 16.5C16.5 18.9853 14.4853 21 12 21"
      stroke="currentColor"
      strokeWidth="currentWidth"
    />
  </>,
  { viewBox: '0 0 24 24' },
);
